import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

const setRaceMetaData = (): SerializedStyles => {
    return css`
        font-style: normal;
        position: relative;
        &::after {
            content: '•';
            margin: 0 8px;
        }
        &:nth-last-of-type(2) {
            &::after {
                content: none;
            }
        }
        &:last-of-type {
            &::after {
                content: none;
            }
        }
    `;
};

export const RaceMetaData = styled('div', { label: 'RaceMetaData' })`
    ${():SerializedStyles => setRaceMetaData()};
`;

export const RaceMetaDataWeather = styled('div', { label: 'RaceMetaDataWeather' })`
    ${():SerializedStyles => setRaceMetaData()};
`;

export const RaceMetaDataHandicap = styled(RaceMetaData, { label: 'RaceMetaDataHandicap' })`
    margin-right: 4px;
    &::after {
        content: none;
    }
`;

export const RaceMetaDataEw = withConfig(theme => styled(RaceMetaData, { label: 'RaceMetaDataEw' })`
    background: ${theme.star.raceSectionHeader.bgColorSecondary};
    border-radius: 4px;
    color: ${theme.star.raceSectionHeader.txtColor};
    margin: 16px 0 0;
    padding: 8px;
    width: 100%;
    &:only-of-type {
        margin-top: 0;
    }
    &:empty {
        display: none;
    }
`);
